import { IIconProps, IconSize } from 'src/interfaces/Icon';
import classNames from 'classnames';
import styles from './styles.module.scss';
import RewindSmallIcon from './small';
import RewindMediumIcon from './medium';
import RewindLargeIcon from './large';

const sizes = {
  small: RewindSmallIcon,
  medium: RewindMediumIcon,
  large: RewindLargeIcon,
};

export interface IRewindIconProps extends IIconProps {
  size: IconSize.small | IconSize.medium | IconSize.large;
  children: number;
}

const RewindIcon = ({ size, className, ...props }: IRewindIconProps) => {
  const Icon = sizes[size];

  return <Icon className={classNames(className, styles.container)} {...props} />;
};

export default RewindIcon;
